import type { ConversationsTransportFilters } from "../transport"
import {
  CONVERSATION_SEARCH_TYPE,
  type ConversationSearchType,
  type MetricValueFilter,
} from "../types"
import type { FilterState } from "../types/filterState"

interface ConversationsTransportFilterInput {
  searchQuery?: string
  searchType?: ConversationSearchType
  agentIds: string[]
  dateRange: FilterState["dateRange"]
  metadataFilters: FilterState["metadataFilters"]
  metricIds: string[]
  metricValueFilters: MetricValueFilter[]
  tagFilters: string[]
}

export function buildConversationsTransportFilters({
  searchQuery,
  searchType,
  agentIds,
  dateRange,
  metadataFilters,
  metricIds,
  metricValueFilters,
  tagFilters,
}: ConversationsTransportFilterInput): ConversationsTransportFilters {
  const trimmedSearchQuery = searchQuery?.trim()

  return {
    search_query: trimmedSearchQuery || undefined,
    search_type: trimmedSearchQuery
      ? (searchType ?? CONVERSATION_SEARCH_TYPE.ALL_FIELDS)
      : undefined,
    start_date: dateRange.start?.toISOString(),
    end_date: dateRange.end?.toISOString(),
    metric_ids: metricIds.length > 0 ? metricIds : undefined,
    agent_ids: agentIds.length > 0 ? agentIds : undefined,
    tag_filters: tagFilters.length > 0 ? tagFilters : undefined,
    metadata_filters:
      metadataFilters.length > 0
        ? metadataFilters.map((filter) => ({
            key: filter.key,
            value: filter.value,
            match_type: filter.matchType,
            ...(filter.values ? { values: filter.values } : {}),
          }))
        : undefined,
    metric_value_filters:
      metricValueFilters.length > 0
        ? metricValueFilters.map((filter) => ({
            metric_id: filter.metricId,
            operator: filter.operator,
            value: filter.value,
            value_type: filter.valueType,
          }))
        : undefined,
  }
}
